<template>
    <div>
        <div class="row my-2 bg-white p-1">
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('wallets.label.withdraw_type') }}</div>
                <input class="form-control"
                       :value="withdrawTypeStr.get(settlement_withdraw_type)"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.total_amount') }}</div>
                <input class="form-control"
                       :value="total_amount"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.status') }}</div>
                <input :class="`form-control text-white bg-${walletTransactionStatusVariant(status, is_reversal)}`"
                       :value="walletTransactionStatusStr.get(status) + (is_reversal ? ' (' + $t('label.reversal') + ')' : '')"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2" v-if="error_message !== ''">
                <div>{{ $t('label.error') }}</div>
                <input class="form-control"
                       :value="error_message"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2" v-if="ref_code !== ''">
                <div>{{ $t('label.ref_code') }}</div>
                <input class="form-control"
                       :value="ref_code"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.source_bank') }}</div>
                <input class="form-control"
                       :value="bankIdStr.get(bank)"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.destination_bank') }}</div>
                <input class="form-control"
                       :value="bankIdStr.get(destination_bank)"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.payment_date') }}</div>
                <input class="form-control"
                       style="direction: ltr;"
                       :value="payment_date"
                       disabled
                >
            </div>
            <div v-show="approximate_payment_date" class="col-12 col-md-4 my-2">
                <div>{{ $t('label.approximate_deposit_time') }}</div>
                <input class="form-control"
                       style="direction: ltr;"
                       :value="approximate_payment_date"
                       disabled
                >
            </div>
            <div class="col-12 col-md-4 my-2">
                <div>{{ $t('label.withdraw_receipt_link') }}</div>
                <div class="d-flex align-items-center">
                    <input class="form-control"
                           style="direction: ltr;"
                           :value="collection_id !== null
                          ?`${settlementReceiptBaseUrl}/wallets/settlement-receipt/collection/${collection_id}`
                          : `${settlementReceiptBaseUrl}/wallets/settlement-receipt/${$route.params.hashid}`"
                           disabled
                    >
                    <div class="d-flex align-items-center pl-3">
                        <div
                            @click="copyText($route.params.hashid)"
                            class="
                              btn
                              m-0
                              pl-2
                              pr-0
                              py-1
                              border-success
                              mr-2
                          "
                            style="cursor: pointer"
                        >
                            <i
                                class="
                                  fas
                                  fa-copy
                                  text-success
                              "
                                id="btn_copy_wallet_hashid"
                            ></i>
                        </div>
                        <a
                            class="btn m-0 px-2 py-1 border-success mx-2"
                            :href="collection_id !== null
                          ?`${settlementReceiptBaseUrl}/wallets/settlement-receipt/collection/${collection_id}`
                          : `${settlementReceiptBaseUrl}/wallets/settlement-receipt/${$route.params.hashid}`"
                            target="_blank"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="#01C1A4" class="bi bi-box-arrow-up-right" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z"/>
                                <path fill-rule="evenodd" d="M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z"/>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
            <div  v-if="detected_by || detected_by === 0" class="col-12 col-md-6">
                <kt-form-group style="margin-top: 33px">
                    <kt-form-label for="detected_by">
                        {{ $t('label.detected_type') }}&nbsp; {{ ':' }}&nbsp;
                    </kt-form-label>
                    <p style="display: inline-block" v-if="detected_by  === 0">
                        {{ $t('label.reversed_automatically') }}
                    </p>
                    <router-link v-else :to="'/users/'+ detected_by.id +'/details'">
                        {{ detected_by.name }}
                    </router-link>
                </kt-form-group>
            </div>
            <div  v-if="reversed_by || reversed_by === 0" class="col-12 col-md-6">
                <kt-form-group style="margin-top: 33px">
                    <kt-form-label for="reversed_by">
                        {{ $t('label.reversed_type') }}&nbsp; {{ ':' }}&nbsp;
                    </kt-form-label>
                    <p style="display: inline-block" v-if="reversed_by  === 0">
                        {{ $t('label.reversed_automatically') }}
                    </p>
                    <router-link v-else :to="'/users/'+ reversed_by.id +'/details'">
                        {{ reversed_by.name }}
                    </router-link>
                </kt-form-group>
            </div>
        </div>
        <div>
            <table class="table table-dark">
                <tr>
                    <td v-text="$t('wallets.label.destination_owner_name')"></td>
                    <td v-text="$t('wallets.label.destination_deposit')"></td>
                    <td v-text="$t('label.amount_rial')"></td>
                </tr>
                <tr>
                    <td v-text="destination_name"></td>
                    <td v-text="settlement_data.destination_number"></td>
                    <td v-text="settlement_data.amount"></td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import {withdrawType, withdrawTypeStr} from "@/constants/withdrawType";
import {walletTransactionStatus, walletTransactionStatusStr, walletTransactionStatusVariant} from "@/constants/walletTransactionStatus";
import {bankId, bankIdStr} from "@/constants/bankId";

export default {
    data() {
        return {
            bankId,
            bankIdStr,
            withdrawType,
            withdrawTypeStr,
            walletTransactionStatus,
            walletTransactionStatusStr,
            walletTransactionStatusVariant,
        }
    },
    computed: {
        destination_name() {
            return this.settlement_data.destination_firstname + ' ' + this.settlement_data.destination_lastname;
        },
        settlementReceiptBaseUrl() {
            return this.$route.params.slug === "starshop" ? "https://my.paystar.shop" : "https://my.paystar.ir"
        }
    },
    methods : {
        copyText(text){
            let value = this.collection_id !== null
                ? `${this.settlementReceiptBaseUrl}/wallets/settlement-receipt/collection/${this.collection_id}`
                : `${this.settlementReceiptBaseUrl}/wallets/settlement-receipt/${text}`
            navigator.clipboard.writeText(
                value
            );
            let el = document.getElementById('btn_copy_wallet_hashid');
            el.classList.remove('fa-copy');
            el.classList.add('fa-check');

                setTimeout(() => {
                    el.classList.remove('fa-check');
                    el.classList.add('fa-copy');
                }, 1500);
            }
        },
        props: {
            settlement_withdraw_type: {
                required: true,
            },
            settlement_data: {
                required: true,
            },
            total_amount: {
                required: true,
            },
            status: {
                required: true,
            },
            error_message: {
                required: true,
            },
            ref_code: {
                required: true,
            },
            is_reversal: {
                required: true,
            },
            bank: {
                required: true,
            },
            destination_bank: {
                required: true,
            },
            payment_date: {
                required: true,
            },
            approximate_payment_date: {
                required: false,
            },
            collection_id: {
                required: false,
            },
            detected_by: {
                required: false,
            },
            reversed_by: {
                required: false,
            }
        },
    }
</script>
